import React from "react";

function AccountSettings() {
  return (
    <div>
      <h2>Account Settings</h2>
      <p>Manage your profile and preferences here.</p>
    </div>
  );
}

export default AccountSettings;